﻿$.fn.dxCtrlScrollView = function custom_dxCtrlScrollView(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlscrollview dx-ctrl");
        this.createInstance(new cdxCtrlScrollView(this, option));
    }
    return this;
}

window.cdxCtrlScrollView = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var dx = null
    function mConstruit() {
        container.empty();
        //if (typeof option.useNative == 'undefined' && bddRef.utiCourantParaJson.parametre_general.scroll_use_native) option.useNative = true
        dx = container.dxScrollView(option).dxScrollView("instance")
    }

    this.content = function () { return dx.content() }
    this.scrollHeight = function () { return dx.scrollHeight() }
    this.scrollTop = function () { return dx.scrollTop() }
    this.clientHeight = function () { return dx.clientHeight() }
    this.scrollTo = function (targetLocation) { dx.scrollTo(targetLocation) }
    this.scrollToElement = function (element) { dx.scrollToElement(element) }
    var lastScrollToValue = 0
    this.smoothScrollTo = function (position, tempo,funcEnd) {
        if (typeof tempo == 'undefined') tempo = 300
        var nativeScrollDiv = dx.element().find(".dx-scrollable-container");
        nativeScrollDiv.stop()
        nativeScrollDiv.animate({ scrollTop: position }, tempo, function () {
            dx.update()
            if (funcEnd) funcEnd()
        })
    }
    this.update = function () { dx.update() }

    this.component = function () { return dx }
    this.element = function () { return container; }

    mConstruit();
}